import { render } from "./Tiktok.vue?vue&type=template&id=01fb1d6a"
import script from "./Tiktok.vue?vue&type=script&lang=js"
export * from "./Tiktok.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__